import React from "react";
import querystring from "query-string";
import {
  HomePage,
  MenuURL,
  requestOptions,
  VIPSDataServiceURL,
  OCCHomePage,
  OCC_ORDER_SUBMIT_URL,
  AppURL,
  ORDERING_PATH,
} from "../../Constants/GlobalConstant";
import "./main.css";

var LTT = require("list-to-tree");
const queryParams = querystring.parse(window.location.search);
var session_id1 = queryParams.session_id;
var vipsOrder = queryParams.vipsOrder;
var OCC = queryParams.OCC;

// Logo Link Logic
var HomePageURL =
  OCC !== null
    ? vipsOrder === "placed"
      ? OCC_ORDER_SUBMIT_URL
      : OCCHomePage
    : HomePage;


const getFormattedUrl = (item, sessionId, sessionStrings = []) => {
  const menuName = (item.MenuName || "").trim().toLowerCase();


  if (menuName === "home") {
    return `${AppURL}/${ORDERING_PATH}/Home?session_id=${sessionId}`;
  }

  let location = item.MenuLocation || "";
  if (!location) return "#";

  location = location.replace("[session_id]", sessionId);
  
  sessionStrings.forEach((s) => {
    if (s.Key === "DivID") {
      location = location.replace("[division_id]", s.Value);
    }
    if (s.Key === "DivDesc") {
      const cleanValue = s.Value ? s.Value.replace(/\s/g, "+") : "";
      location = location.replace("[division_description]", cleanValue);
    }
  });

  if (location.toLowerCase().startsWith("https")) {
    return location;
  }


  return `${MenuURL}/` + location;
};

const MenuSub = (props) => {
  return (
    <>
      {props.data.map((item) => (
        <li
          key={item.MenuID}
          className={item.child?.length ? "dropdown-submenu" : ""}
        >
          <a href={getFormattedUrl(item, session_id1, props.sessionStrings)}>
            {item.MenuName}
          </a>
          {item.child?.length ? (
            <ul className="dropdown-menu">
              <MenuSub data={item.child} sessionStrings={props.sessionStrings}></MenuSub>
            </ul>
          ) : null}
        </li>
      ))}
    </>
  );
};

export default class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      menu: [],
      loginUser: "",
    };
  }

  componentDidMount() {
    let loginUser = "";
    const webString = this.props.post?.paxWebSessionStrings || [];
    webString.forEach(function (item) {
      if (item.Key === "user_id") {
        loginUser = item.Value;
      }
    });

    fetch(`${VIPSDataServiceURL}/Menu/GetMenus?user_id=${loginUser}`, requestOptions)
      .then((response) => response.json())
      .then((data) => this.setState({ menu: data, loginUser: loginUser }));
  }

  render() {
    // Transform API response into a Nested Tree
    var ltt = new LTT(this.state.menu, {
      key_id: "MenuID",
      key_parent: "ParentID",
    });
    var menuTree = ltt.GetTree();
    const sessionStrings = this.props.post?.paxWebSessionStrings || [];

    return (
      <div style={{ top: "0", width: "100%", zIndex: "999999" }} id="header">
        {/* Utility Bar */}
        <div className="preNav" style={{ background: "#f5f5f5" }}>
          <div className="contactModule">
            <a>Welcome {this.state.loginUser}</a>
            <a href={`${AppURL}/${ORDERING_PATH}/Home?session_id=${this.props.session_id}`}>Home</a>
            <a href={`${MenuURL}/ContactUs.aspx?session_id=${this.props.session_id}`}>Contact Us</a>
            <a href={`${AppURL}/${ORDERING_PATH}/changepassword?session_id=${this.props.session_id}`}>Change Password</a>
            <a href={`${MenuURL}/pages/Administration/useradmin/DeleteSession.aspx?session_id=${this.props.session_id}`}>Log off</a>
          </div>
        </div>

        {/* Main Navigation */}
        <div className="topNav buHeader">
          <div className="titleNav">
            <a className="logo" href={HomePageURL}>
              <img src={require("../../images/RBIS-Logo-New.png")} height="45" width="290" alt="logo" />
            </a>
          </div>

          <div className="mainNav">
            <ul className="navLinks">
              {menuTree && menuTree.map((item) => (
                <li key={item.MenuID}>
                  <div className="dropdown">
                    <a className="dropbtn" href={getFormattedUrl(item, this.props.session_id, sessionStrings)}>
                      {item.MenuName}
                      {item.child?.length ? <span className="caret"></span> : ""}
                    </a>
                    {item.child?.length ? (
                      <ul className="dropdown-menu multi-level">
                        <MenuSub data={item.child} sessionStrings={sessionStrings} />
                      </ul>
                    ) : null}
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    );
  }
}